/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LocationModel { 
    locationId?: number;
    customerClass?: string | null;
    vendorClass?: string | null;
    locationIdentifier?: string | null;
    locationName?: string | null;
    locationAddress1?: string | null;
    locationAddress2?: string | null;
    locationCity?: string | null;
    locationState?: string | null;
    locationZipCode?: string | null;
    locationPhoneNumber?: string | null;
    locationEmailAddress?: string | null;
    locationWebsite?: string | null;
    locationTimeZone?: string | null;
    statusId?: number;
}

